export default "__VITE_ASSET__CWjks3qS__"